import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { BookNoSearch } from '../models/bookno-receipt-model';

@Injectable({
  providedIn: 'root'
})
export class BooknumberService {

  constructor(private http:HttpClient) { }


  lFN_GetRceiptsDtlBookNumber(l_bookNoformData: BookNoSearch){
   return this.http.post(`${environment.ROOT_URL}/jsyogaccounts/bookdetails`, l_bookNoformData , { withCredentials: true, responseType: 'text', observe: 'response' });
  }

  
}
